export default __webpack_public_path__ + "static/media/110.5e1cb831.webp";